import { render } from "./batchDetail.vue?vue&type=template&id=61d42318&scoped=true&ts=true"
import script from "./batchDetail.vue?vue&type=script&lang=tsx"
export * from "./batchDetail.vue?vue&type=script&lang=tsx"

import "./batchDetail.vue?vue&type=style&index=0&id=61d42318&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d42318"]])

export default __exports__